import { cn } from '@utils/helpers';
import { XIcon } from 'lucide-react';
import { useFragment } from 'react-relay';
import { CategoryInfoEntry } from '../categoryInfoEntry';
import { categoryInfoFragment } from './CategoryInfo.relay';
import type { CategoryInfoPropsType } from './types';

const CategoryInfo: React.FC<CategoryInfoPropsType> = (props: CategoryInfoPropsType) => {
  const info = useFragment(categoryInfoFragment, props.info);

  if (!info.entries) {
    return null;
  }

  return (
    <div
      className={cn(
        'px-[30px] py-0 opacity-0 transition-all duration-500 ease-in-out',
        props.visible ? 'my-5 border border-solid border-[#ccc] p-[30px] opacity-100 max-[1100px]:my-[10px] max-[1100px]:mb-[15px] desktop:col-span-2' : 'border border-solid border-transparent',
      )}
    >
      <div className={`grid overflow-hidden transition-[grid-template-rows] duration-150 ease-out ${props.visible ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'}`}>
        <div className="relative overflow-hidden flex items-center justify-between">
          {info.entries.map((entry) => (
            <CategoryInfoEntry key={`CategoryInfo-${Math.random()}`} entry={entry} />
          ))}
          <XIcon
            className="size-3 text-black hover:cursor-pointer"
            onClick={(e) => {
              e.preventDefault();
              props.close();
            }}
          />
        </div>
      </div>
    </div>
  );
};

export { CategoryInfo };
